import { default as approval } from './approval/routes'
import { default as schedule } from './schedule/routes'

export default [
    ...approval,
    ...schedule
]

